import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import { getSupplier, createSaveSupplier, updateSparePartDeliverySetting } from '../../../actions/spareparts'
import { getDracarStores } from '../../../actions/settings'

// Components
import Phone from './../../../shared/components/Phone'

// Elements
import Col from './../../../shared/elements/col'
import Row from './../../../shared/elements/row'
import Panel from './../../../shared/elements/panel'
import Text from './../../../shared/elements/text'
import Textarea from './../../../shared/elements/textarea'
import Switch from './../../../shared/elements/switch'
import LabelWrapper from './../../../shared/elements/labelWrapper'
import Inline from './../../../shared/elements/inline'
import DropDown from '../../../shared/elements/dropDown'
import AddButton from '../../../shared/elements/addButton'
import RemoveButton from '../../../shared/elements/removeButton'
import PanelHeader from '../../../shared/elements/panelHeader'
import Grid from '../../../shared/elements/grid'
import Check from '../../../shared/elements/check'
import Divider from '../../../shared/elements/divider'
import Time from '../../../shared/elements/time'
import Label from '../../../shared/elements/label'

// Styles
import './view.scss'

// Utils
import { translation } from '../../../utils/helpers'
import SparePartDeliverySettingEditModal from '../../../shared/modals/SparePartDeliverySettingEditModal'
import Radio from '../../../shared/elements/radio'

const SendPricesSettingType = {
  None: 0,
  AllBrand: 1,
  SelectedBrand: 2
}
class View extends Component {
  constructor (props) {
    super(props)
    this.state = {
      type: 'edit',
      orderEmail: '',
      supplier: {
        Id: 0,
        CompanyName: '',
        Address: '',
        ZipCode: '',
        City: '',
        PhoneNumber: '',
        PhoneCode: this.props.phonecode,
        Note: '',
        Active: true,
        PickupSelf: false,
        AutoOrder: false,
        Contacts: [],
        CustomerNumber: '',
        IncludeRequisitionNumberInMail: false,
        DeliverySettings: [],
        DeliverySettingsUrgent: [],
        DracarCompanyStoreId: '',
        SendPricesSettingType: SendPricesSettingType.None,
        SparePartBrandEmailRules: [],
        OrderingReplyEmail: '',
        ReplyToCompanyMail: false,
        CompanyContactPhoneNumber: '',
        CompanyContactPhoneCode: this.props.phonecode
      },

      SelectedSparePartBrandEmailRule: '',
      brands: [],
      dracarStores: [],
      newDeliveryRule: {},
      OrderBefore: '10:00',
      ExpectedDeliveryDays: 0,
      ExpectedDeliveryTime: '15:00',

      showDeliverySettingModal: {}
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onInputChangeSave = this.onInputChangeSave.bind(this)
    this.updateSupplier = this.updateSupplier.bind(this)
    this.saveAddSupplier = this.saveAddSupplier.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
    this.onPhoneBlur = this.onPhoneBlur.bind(this)
    this.renderContacts = this.renderContacts.bind(this)
  }

  componentDidMount () {
    this.getSupplier(this.props)
    this.getDracarStores()
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.Id !== nextProps.item.Id) {
      this.getSupplier(nextProps)
    }
  }

  getSupplier (props) {
    if (typeof props.item.Id !== 'undefined' && props.item.Id > 0) {
      this.props.getSupplier(props.item.Id).then(res => {
        this.setState({
          supplier: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  getDracarStores () {
    this.props.getDracarStores(this.props.auth.user.ShopId).then(res => {
      this.setState({
        dracarStores: res.data.DracarCompanyStores
      })
    }, (err) => {
      console.log(err)
    })
  }

  updateSupplier () {
    this.props.createSaveSupplier(this.state.supplier).then((res) => {
      this.props.onSave(res.data, this.state.type)
      let newState = { supplier: res.data }
      if (this.state.type === 'create') {
        newState.type = 'edit'
      }
      this.setState({
        ...newState
      })
    }, (err) => {
    // Toastr
      if (Array.isArray(err.response.data.Errors) && err.response.data.Errors.length > 0) {
        let errors = err.response.data.Errors
        let errText = ''
        for (let i = 0; i < errors.length; i++) {
          let dictKey = errors[i].DictionaryKey
          if (errText !== '') errText += '<br/>'
          errText += translation(dictKey)
        }
        window.toastr.error(translation(errText), translation('216'))
      } else {
        window.toastr.error(translation('16431'), translation('216'))
      }
    })
  }

  saveAddSupplier () {
    console.log('save suplier')
    if (this.state.type !== 'create') this.updateSupplier()
  }

  onInputChange (name, e) {
    console.log('onInputChange', name, e)

    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (e === undefined) {
        e = name
      }
      name = e.target.name
      value = e.target.value
    }

    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }

    this.setState({
      supplier: {
        ...this.state.supplier,
        [name]: value
      }
    })
  }

  onInputChangeSave (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (e === undefined) {
        e = name
      }
      name = e.target.name
      value = e.target.value
    }

    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }

    if (e.target.type === 'radio') {
      value = e.target.value
      name = 'SendPricesSettingType'
    }

    this.setState({
      supplier: {
        ...this.state.supplier,
        [name]: value
      }
    }, this.saveAddSupplier)
  }

  onPhoneChange (name, e) {
    let value = ''
    value = name.target.value
    if (name.target.name === 'PhoneNumber') {
      name = 'PhoneNumber'
      this.setState({
        supplier: {
          ...this.state.supplier,
          [name]: value
        }
      })
    } else {
      this.setState({
        supplier: {
          ...this.state.supplier,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      }, this.saveAddSupplier)
    }
  }

  onPhoneBlur (name, e) {
    let value = ''
    value = name.target.value
    if (name.target.name === 'PhoneNumber') {
      name = 'PhoneNumber'
      this.setState({
        supplier: {
          ...this.state.supplier,
          [name]: value
        }
      }, this.saveAddSupplier)
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      orderEmail: '',
      supplier: {
        Id: 0,
        CompanyName: '',
        Address: '',
        ZipCode: '',
        City: '',
        PhoneNumber: '',
        PhoneCode: this.props.phonecode,
        Note: '',
        Active: true,
        PickupSelf: false,
        AutoOrder: false,
        Contacts: [],
        CustomerNumber: '',
        OrderingReplyEmail: '',
        ReplyToCompanyMail: false,
        CompanyContactPhoneNumber: '',
        CompanyContactPhoneCode: this.props.phonecode,
        SparePartBrandEmailRules: []
      }
    })
  }

  renderSupplier () {
    let supplier = this.state.supplier

    return (
      <Panel title={translation('16424')}>
        <Text name='CompanyName' value={supplier.CompanyName || ''} onChange={this.onInputChange} onBlur={this.saveAddSupplier} labelText={translation('30')} />
        <Text name='Address' value={supplier.Address || ''} onChange={this.onInputChange} onBlur={this.saveAddSupplier} labelText={translation('25')} />
        <Text name='ZipCode' value={supplier.ZipCode || ''} onChange={this.onInputChange} onBlur={this.saveAddSupplier} labelText={translation('40')} />
        <Text name='City' value={supplier.City || ''} onChange={this.onInputChange} onBlur={this.saveAddSupplier} labelText={translation('37')} />
        <LabelWrapper labelText={translation('38')}>
          <Phone onChange={this.onPhoneChange} onBlur={this.onPhoneBlur} code={supplier.PhoneCode || ''} number={supplier.PhoneNumber || ''} />
        </LabelWrapper>
        <Text name='CustomerNumber' value={supplier.CustomerNumber || ''} onChange={this.onInputChange} onBlur={this.saveAddSupplier} labelText={translation('16515')} />
        <Textarea name='Note' onChange={this.onInputChange} value={supplier.Note || ''} onBlur={this.saveAddSupplier} labelText={translation('93')} />
        <Switch name='Active' checked={supplier.Active || false} onChange={this.onInputChangeSave} labelText={translation('295')} />
      </Panel>
    )
  }

  renderSparePartBrandEmail () {
    let { supplier } = this.state
    let cols = ['auto', '48px']
    let newBrand = {
      id: 0,
      BrandName: this.state.SelectedSparePartBrandEmailRule,
      IsDeleted: false
    }

    const onClick = () => {
      this.setState({
        supplier: {
          ...supplier,
          SparePartBrandEmailRules: [newBrand]
        }
      }, this.saveAddSupplier)
      this.state.SelectedSparePartBrandEmailRule = ''
    }

    const onChange = e => {
      this.setState({
        [e.target.name]: e.target.value
      })
    }

    const renderSelectedBrand = (brand, key) => {
      const onDelete = _ => {
        brand.IsDeleted = true
        this.setState({
          supplier: {
            ...supplier,
            SparePartBrandEmailRules: [...supplier.SparePartBrandEmailRules]
          }
        }, this.saveAddSupplier)
      }

      return (
        <Grid key={key} cols={cols} spacing={1}>
          <Label>{brand.BrandName}</Label>
          <RemoveButton onClick={onDelete} size='m' />
        </Grid>
      )
    }

    const brandOptions = this.props.brands.map((b, index) => {
      if (index === 0) {
        return { value: b.Name, label: translation(b.Name), disabled: true }
      }

      return { value: b.Name, label: b.Name }
    })
    return (
      <div>
        {supplier.SparePartBrandEmailRules.map(renderSelectedBrand)}
        <Grid cols={cols} spacing={1}>
          <DropDown name='SelectedSparePartBrandEmailRule' value={this.state.SelectedSparePartBrandEmailRule} onChange={onChange} options={brandOptions} />
          <AddButton onClick={onClick} />
        </Grid>
      </div>
    )
  }

  renderContacts () {
    let { supplier, orderEmail } = this.state
    let cols = ['auto', '48px']

    const onClick = _ => {
      this.setState({
        orderEmail: '',
        supplier: {
          ...supplier,
          Contacts: [...supplier.Contacts, { Email: orderEmail }]
        }
      }, this.saveAddSupplier)
    }

    const onChange = e => {
      this.setState({
        [e.target.name]: e.target.value
      })
    }

    const renderContact = (contact, key) => {
      const onDelete = _ => {
        contact.IsDeleted = true
        this.setState({
          supplier: {
            ...supplier,
            Contacts: [...supplier.Contacts]
          }
        }, this.saveAddSupplier)
      }

      return (
        <Grid key={key} cols={cols} spacing={1}>
          <Text readOnly value={contact.Email} size='m' />
          <RemoveButton onClick={onDelete} size='m' />
        </Grid>
      )
    }

    return (
      <div>
        <Grid cols={cols} spacing={1}>
          <Label>{translation('17862')}</Label>
          <div />
        </Grid>
        <Grid cols={cols} spacing={1}>
          <Text name='orderEmail' value={orderEmail} onChange={onChange} />
          <AddButton onClick={onClick} />
        </Grid>
        {supplier.Contacts.map(renderContact)}
      </div>
    )
  }

  renderBooking () {
    let supplier = this.state.supplier
    const usesDracar = () => {
      return this.props.dracarUsable
    }
    const dracarStoreList = (val, key) => {
      return (
        <option key={key} value={val.StoreId}>{val.StoreName}</option>
      )
    }

    let autoOrderSwitchEnabled = supplier && supplier.Contacts && supplier.Contacts.some(x => x.Email && x.Email.trim() !== '')
    let keyLoopStoreText = ''
    switch (this.props.auth.accountingSystem) {
      case 4:
        keyLoopStoreText = 16761
        break
      case 6:
        keyLoopStoreText = 18148
        break
    }

    return (
      <Panel title={translation('16426')}>
        {this.renderContacts()}
        <Switch name='AutoOrder' disabled={!autoOrderSwitchEnabled} checked={supplier.AutoOrder || false} onChange={this.onInputChangeSave} labelText={translation('16428')} />
        <Switch name='IncludeRequisitionNumberInMail' checked={supplier.IncludeRequisitionNumberInMail} onChange={this.onInputChangeSave} labelText={translation('16582')} />
        {usesDracar() && (
          <DropDown labelText={keyLoopStoreText} name='DracarCompanyStoreId' value={supplier.DracarCompanyStoreId} onChange={this.onInputChangeSave}>
            <option value={'0'}>{translation('16762')}</option>
            {this.state.dracarStores.map(dracarStoreList)}
          </DropDown>
        )}

        <label>{translation('18069')}</label>
        <Radio name='AllBrand' value={SendPricesSettingType.AllBrand} checked={supplier.SendPricesSettingType === SendPricesSettingType.AllBrand} onChange={this.onInputChangeSave} labelText={translation('18070')} />
        <Radio name='None' value={SendPricesSettingType.None} checked={supplier.SendPricesSettingType === SendPricesSettingType.None} onChange={this.onInputChangeSave} labelText={translation('433')} />
        <Radio name='SelectedBrand' value={SendPricesSettingType.SelectedBrand} checked={supplier.SendPricesSettingType === SendPricesSettingType.SelectedBrand} onChange={this.onInputChangeSave} labelText={translation('18071')} />
        {this.renderSparePartBrandEmail()}
      </Panel>
    )
  }

  renderOrderingReply () {
    let supplier = this.state.supplier

    const onCompanyContactPhoneChange = (name) => {
      let value = ''
      value = name.target.value
      if (name.target.name === 'PhoneNumber') {
        name = 'CompanyContactPhoneNumber'
        this.setState({
          supplier: {
            ...this.state.supplier,
            [name]: value
          }
        })
      } else {
        this.setState({
          supplier: {
            ...this.state.supplier,
            CompanyContactPhoneCode: {
              Id: Number(value.Id)
            }
          }
        }, this.saveAddSupplier)
      }
    }

    const onCompanyPhoneBlur = (name) => {
      let value = ''
      value = name.target.value
      if (name.target.name === 'PhoneNumber') {
        name = 'CompanyContactPhoneNumber'
        this.setState({
          supplier: {
            ...this.state.supplier,
            [name]: value
          }
        }, this.saveAddSupplier)
      }
    }

    return (
      <Panel title={translation('18077')}>
        <Text name='OrderingReplyEmail' value={supplier.OrderingReplyEmail || ''} onChange={this.onInputChange} onBlur={this.saveAddSupplier} labelText={translation('151')} />
        <Switch name='ReplyToCompanyMail' checked={supplier.ReplyToCompanyMail || false} onChange={this.onInputChangeSave} labelText={translation('18074')} />

        <LabelWrapper labelText={translation('38')}>
          <Phone onChange={onCompanyContactPhoneChange} onBlur={onCompanyPhoneBlur} code={supplier.CompanyContactPhoneCode || ''} number={supplier.CompanyContactPhoneNumber || ''} />
        </LabelWrapper>
      </Panel>
    )
  }

  renderPickup () {
    let supplier = this.state.supplier

    return (
      <Panel title={translation('579')}>
        <Switch name='PickupSelf' checked={supplier.PickupSelf || false} onChange={this.onInputChangeSave} labelText={translation('16427')} />
      </Panel>
    )
  }

  // RENDER NORMAL DELIVERY
  renderDeliverySettings () {
    const supplier = this.state.supplier
    const deliveryCols = [ 1, 1, 1, '32px' ]

    const onChange = (e) => {
      const { name, value } = e.target

      this.setState({
        [name]: value
      })
    }

    const updateDeliverySetting = (setting) => {
      return this.props.updateSparePartDeliverySetting(setting).then(() => {
        this.getSupplier(this.props)
        // window.toastr.success(translation('16429'), translation('13424'))
      }).catch(() => {
        window.toastr.error('', translation('216'))
      })
    }

    const addSetting = () => {
      const { supplier, brands } = this.state

      if (brands.length === 0) {
        window.toastr.error(translation('16525'), translation('216'))
        return
      }

      const newSetting = {
        SparePartSupplierId: supplier.Id,
        DeliveryType: 1,
        BrandRules: [
          ...brands.map(b => ({ BrandName: b }))
        ]
      }

      updateDeliverySetting(newSetting).then(() => {
        this.setState({
          brands: []
        })
      })
    }

    // DELIVERY SETTING
    const renderDeliverySetting = (setting, key) => {
      const onEditBrandSave = (updatedBrands) => {
        for (let i = 0; i < setting.BrandRules.length; i++) {
          const brandRule = setting.BrandRules[i]

          if (!updatedBrands.includes(brandRule.BrandName)) {
            brandRule.IsDeleted = true
          }
        }

        const newBrands = updatedBrands.filter(ub => !setting.BrandRules.some(br => br.BrandName === ub))
        setting.BrandRules = [
          ...setting.BrandRules,
          ...newBrands.map(nb => ({ BrandName: nb }))
        ]

        return updateDeliverySetting(setting)
      }

      const toggleBrandModal = () => {
        this.setState({
          showDeliverySettingModal: {
            [setting.Id]: !this.state.showDeliverySettingModal[setting.Id]
          }
        })
      }

      // DELIVERY RULE
      const renderDeliveryRule = (deliveryRule, key) => {
        const removeDeliveryRule = () => {
          const settingObj = { ...setting }

          const rule = settingObj.DeliveryRules.find(dr => dr.Id === deliveryRule.Id)
          rule.IsDeleted = true

          updateDeliverySetting(settingObj)
        }

        const formatTime = (time) => {
          return time.substring(0, 5)
        }

        return (
          <Grid cols={deliveryCols} align='center' spacing={1} key={key}>
            <div>{formatTime(deliveryRule.OrderBefore)}</div>
            <div>{deliveryRule.ExpectedDeliveryDays}</div>
            <div>{formatTime(deliveryRule.ExpectedDeliveryTime)}</div>
            <RemoveButton onClick={removeDeliveryRule} size='s' />
          </Grid>
        )
      }

      // NEW DELIVERY RULE
      const renderNewDeliveryRule = () => {
        const { OrderBefore, ExpectedDeliveryDays, ExpectedDeliveryTime } = this.state.newDeliveryRule[setting.Id] || { OrderBefore: '', ExpectedDeliveryDays: 0, ExpectedDeliveryTime: '' }

        const onNewDeliveryChange = (e) => {
          let { name, value } = e.target

          if (name === 'ExpectedDeliveryDays') {
            if (!/^[0-9]*$/.test(value)) { return }

            // Only 0-50 values
            value = parseInt(value)
            if (!isNaN(value)) {
              if (value > 50) value = 50
              else if (value < 0) value = 0
            }
            value = value || ''
          }

          this.setState({
            newDeliveryRule: {
              ...this.state.newDeliveryRule,
              [setting.Id]: {
                ...this.state.newDeliveryRule[setting.Id],
                [name]: value
              }
            }
          })
        }

        const validateInput = () => {
          if (!OrderBefore || (typeof parseInt(ExpectedDeliveryDays) !== 'number') || !ExpectedDeliveryTime) {
            window.toastr.error(translation('16531'), translation('216'))
            return false
          }

          if (!ExpectedDeliveryDays || ExpectedDeliveryDays === 0) {
            const beforeTime = parseInt(OrderBefore.replace(':', ''))
            const afterTime = parseInt(ExpectedDeliveryTime.replace(':', ''))

            if (afterTime < beforeTime) {
              window.toastr.error(translation('16521'), translation('216'))
              return false
            }
          }

          return true
        }

        const addNewDeliveryRule = () => {
          if (!validateInput()) {
            return
          }

          const settingObj = { ...setting }

          const newDeliveryRule = {
            OrderBefore,
            ExpectedDeliveryDays,
            ExpectedDeliveryTime
          }

          settingObj.DeliveryRules.push(newDeliveryRule)

          updateDeliverySetting(settingObj).then(() => {
            this.setState({
              newDeliveryRule: {
                ...this.state.newDeliveryRule,
                [setting.Id]: null
              }
            })
          })
        }

        return (
          <Grid cols={deliveryCols} align='center'>
            <Time name='OrderBefore' value={OrderBefore || ''} onChange={onNewDeliveryChange} size='m' simple />
            <Text name='ExpectedDeliveryDays' value={ExpectedDeliveryDays || 0} onChange={onNewDeliveryChange} size='m' simple />
            <Time name='ExpectedDeliveryTime' value={ExpectedDeliveryTime || ''} onChange={onNewDeliveryChange} onBlur={() => validateInput()} size='m' simple />
            <AddButton onClick={addNewDeliveryRule} size='m' />
          </Grid>
        )
      }

      // BRAND RULE
      const renderBrandRule = (brandRule, key) => {
        const onBrandChange = (e) => {
          const { name, value, checked, type } = e.target

          const rule = setting.BrandRules.find(br => br.Id === brandRule.Id)
          if (name === 'Discount') {
            rule[name] = value
          } else if (name === 'StockItemsOnly') {
            rule[name] = checked
          }

          var settingIndex = supplier.DeliverySettings.findIndex(dr => dr.Id === setting.Id)
          supplier.DeliverySettings[settingIndex] = setting

          this.setState({
            supplier: supplier
          }, () => {
            if (type === 'checkbox') {
              const updatedSetting = this.state.supplier.DeliverySettings.find(dr => dr.Id === setting.Id)
              updateDeliverySetting(updatedSetting)
            }
          })
        }

        const onBlur = (e) => {
          const settingObj = { ...setting }

          updateDeliverySetting(settingObj)
        }

        return (
          <Grid align='center' key={key}>
            <div>{brandRule.BrandName}</div>
            <Grid cols={[ 1, 'max-content' ]} align='center'>
              <Text name='Discount' value={brandRule.Discount} onChange={onBrandChange} onBlur={onBlur} size='m' simple />
              {translation('16523')}
            </Grid>
            <Check name='StockItemsOnly' checked={brandRule.StockItemsOnly} onChange={onBrandChange} onBlur={onBlur} labelText={16524} />
          </Grid>
        )
      }

      const label = setting.BrandRules.reduce((prev, rule, index) => {
        if (index === 0) {
          return rule.BrandName
        }

        return `${prev}, ${rule.BrandName}`
      }, '')
      return (
        <div key={key}>
          <Inline>
            <PanelHeader text={label} />
            <AddButton onClick={toggleBrandModal} size='s' />
          </Inline>

          {setting.DeliveryRules.length === 0 && (
            <div className='sparePartSupplier__danger'>{translation('16522')}</div>
          )}

          <Grid cols={deliveryCols} spacing={1}>
            <div>{translation('16518')}</div>
            <div>{translation('16519') + ' (0-50)'}</div>
            <div>{translation('16520')}</div>
            <div />
          </Grid>
          {setting.DeliveryRules.map(renderDeliveryRule)}
          {renderNewDeliveryRule()}

          <Divider size={2} noLine />
          {setting.BrandRules.map(renderBrandRule)}
          <Divider />

          <SparePartDeliverySettingEditModal
            show={this.state.showDeliverySettingModal[setting.Id]}
            selected={setting.BrandRules.map(br => br.BrandName)}
            onSave={onEditBrandSave}
            onClose={toggleBrandModal}
          />
        </div>
      )
    }

    const brandOptions = this.props.brands.map((b, index) => {
      if (index === 0) {
        return { value: b.Name, label: translation(b.Name), disabled: true }
      }

      return { value: b.Name, label: b.Name }
    })
    return (
      <Panel title={translation('193')}>
        <LabelWrapper labelText={translation('16517')}>
          <Inline fillChildNum={[0]} block>
            <DropDown name='brands' value={this.state.brands} onChange={onChange} options={brandOptions} isMulti />
            <AddButton onClick={addSetting} />
          </Inline>
        </LabelWrapper>

        {supplier.DeliverySettings.map(renderDeliverySetting)}
      </Panel>
    )
  }

  // RENDER URGENT DELIVERY
  renderUrgentDeliverySettings () {
    const supplier = this.state.supplier
    const deliveryCols = [ 1, 1, 1, '32px' ]

    const onChange = (e) => {
      const { name, value } = e.target

      this.setState({
        [name]: value
      })
    }

    const updateDeliverySetting = (setting) => {
      return this.props.updateSparePartDeliverySetting(setting).then(() => {
        this.getSupplier(this.props)
        // window.toastr.success(translation('16429'), translation('13424'))
      }).catch(() => {
        window.toastr.error('', translation('216'))
      })
    }

    const addSetting = () => {
      const { supplier, brands } = this.state

      if (brands.length === 0) {
        window.toastr.error(translation('16525'), translation('216'))
        return
      }

      const newSetting = {
        SparePartSupplierId: supplier.Id,
        DeliveryType: 2,
        BrandRules: [
          ...brands.map(b => ({ BrandName: b }))
        ]
      }

      updateDeliverySetting(newSetting).then(() => {
        this.setState({
          brands: []
        })
      })
    }

    // DELIVERY SETTING
    const renderDeliverySetting = (setting, key) => {
      const onEditBrandSave = (updatedBrands) => {
        for (let i = 0; i < setting.BrandRules.length; i++) {
          const brandRule = setting.BrandRules[i]

          if (!updatedBrands.includes(brandRule.BrandName)) {
            brandRule.IsDeleted = true
          }
        }

        const newBrands = updatedBrands.filter(ub => !setting.BrandRules.some(br => br.BrandName === ub))
        setting.BrandRules = [
          ...setting.BrandRules,
          ...newBrands.map(nb => ({ BrandName: nb }))
        ]

        return updateDeliverySetting(setting)
      }

      const toggleBrandModal = () => {
        this.setState({
          showDeliverySettingModal: {
            [setting.Id]: !this.state.showDeliverySettingModal[setting.Id]
          }
        })
      }

      // DELIVERY RULE
      const renderDeliveryRule = (deliveryRule, key) => {
        const removeDeliveryRule = () => {
          const settingObj = { ...setting }

          const rule = settingObj.DeliveryRules.find(dr => dr.Id === deliveryRule.Id)
          rule.IsDeleted = true

          updateDeliverySetting(settingObj)
        }

        const formatTime = (time) => {
          return time.substring(0, 5)
        }

        return (
          <Grid cols={deliveryCols} align='center' spacing={1} key={key}>
            <div>{formatTime(deliveryRule.OrderBefore)}</div>
            <div>{deliveryRule.ExpectedDeliveryDays}</div>
            <div>{formatTime(deliveryRule.ExpectedDeliveryTime)}</div>
            <RemoveButton onClick={removeDeliveryRule} size='s' />
          </Grid>
        )
      }

      // NEW DELIVERY RULE
      const renderNewDeliveryRule = () => {
        const { OrderBefore, ExpectedDeliveryDays, ExpectedDeliveryTime } = this.state.newDeliveryRule[setting.Id] || { OrderBefore: '', ExpectedDeliveryDays: 0, ExpectedDeliveryTime: '' }

        const onNewDeliveryChange = (e) => {
          let { name, value } = e.target

          if (name === 'ExpectedDeliveryDays') {
            if (!/^[0-9]*$/.test(value)) { return }

            // Only 0-50 values
            value = parseInt(value)
            if (!isNaN(value)) {
              if (value > 50) value = 50
              else if (value < 0) value = 0
            }
            value = value || ''
          }

          this.setState({
            newDeliveryRule: {
              ...this.state.newDeliveryRule,
              [setting.Id]: {
                ...this.state.newDeliveryRule[setting.Id],
                [name]: value
              }
            }
          })
        }

        const validateInput = () => {
          if (!OrderBefore || (typeof parseInt(ExpectedDeliveryDays) !== 'number') || !ExpectedDeliveryTime) {
            window.toastr.error(translation('16531'), translation('216'))
            return false
          }

          if (!ExpectedDeliveryDays || ExpectedDeliveryDays === 0) {
            const beforeTime = parseInt(OrderBefore.replace(':', ''))
            const afterTime = parseInt(ExpectedDeliveryTime.replace(':', ''))

            if (afterTime < beforeTime) {
              window.toastr.error(translation('16521'), translation('216'))
              return false
            }
          }

          return true
        }

        const addNewDeliveryRule = () => {
          if (!validateInput()) {
            return
          }

          const settingObj = { ...setting }

          const newDeliveryRule = {
            OrderBefore,
            ExpectedDeliveryDays,
            ExpectedDeliveryTime
          }

          settingObj.DeliveryRules.push(newDeliveryRule)

          updateDeliverySetting(settingObj).then(() => {
            this.setState({
              newDeliveryRule: {
                ...this.state.newDeliveryRule,
                [setting.Id]: null
              }
            })
          })
        }

        return (
          <Grid cols={deliveryCols} align='center'>
            <Time name='OrderBefore' value={OrderBefore || ''} onChange={onNewDeliveryChange} size='m' simple />
            <Text name='ExpectedDeliveryDays' value={ExpectedDeliveryDays || 0} onChange={onNewDeliveryChange} size='m' simple />
            <Time name='ExpectedDeliveryTime' value={ExpectedDeliveryTime || ''} onChange={onNewDeliveryChange} onBlur={() => validateInput()} size='m' simple />
            <AddButton onClick={addNewDeliveryRule} size='m' />
          </Grid>
        )
      }

      // BRAND RULE
      const renderBrandRule = (brandRule, key) => {
        const onBrandChange = (e) => {
          const { name, value, checked, type } = e.target

          const rule = setting.BrandRules.find(br => br.Id === brandRule.Id)
          if (name === 'Discount') {
            rule[name] = value
          } else if (name === 'StockItemsOnly') {
            rule[name] = checked
          }

          var settingIndex = supplier.DeliverySettingsUrgent.findIndex(dr => dr.Id === setting.Id)
          supplier.DeliverySettingsUrgent[settingIndex] = setting

          this.setState({
            supplier: supplier
          }, () => {
            if (type === 'checkbox') {
              const updatedSetting = this.state.supplier.DeliverySettingsUrgent.find(dr => dr.Id === setting.Id)
              updateDeliverySetting(updatedSetting)
            }
          })
        }

        const onBlur = (e) => {
          const settingObj = { ...setting }

          updateDeliverySetting(settingObj)
        }

        return (
          <Grid align='center' key={key}>
            <div>{brandRule.BrandName}</div>
            <Grid cols={[ 1, 'max-content' ]} align='center'>
              <Text name='Discount' value={brandRule.Discount} onChange={onBrandChange} onBlur={onBlur} size='m' simple />
              {translation('16523')}
            </Grid>
            <Check name='StockItemsOnly' checked={brandRule.StockItemsOnly} onChange={onBrandChange} onBlur={onBlur} labelText={16524} />
          </Grid>
        )
      }

      const label = setting.BrandRules.reduce((prev, rule, index) => {
        if (index === 0) {
          return rule.BrandName
        }

        return `${prev}, ${rule.BrandName}`
      }, '')
      return (
        <div key={key}>
          <Inline>
            <PanelHeader text={label} />
            <AddButton onClick={toggleBrandModal} size='s' />
          </Inline>

          {setting.DeliveryRules.length === 0 && (
            <div className='sparePartSupplier__danger'>{translation('16522')}</div>
          )}

          <Grid cols={deliveryCols} spacing={1}>
            <div>{translation('16518')}</div>
            <div>{translation('16519') + ' (0-50)'}</div>
            <div>{translation('16520')}</div>
            <div />
          </Grid>
          {setting.DeliveryRules.map(renderDeliveryRule)}
          {renderNewDeliveryRule()}

          <Divider size={2} noLine />
          {setting.BrandRules.map(renderBrandRule)}
          <Divider />

          <SparePartDeliverySettingEditModal
            show={this.state.showDeliverySettingModal[setting.Id]}
            selected={setting.BrandRules.map(br => br.BrandName)}
            onSave={onEditBrandSave}
            onClose={toggleBrandModal}
          />
        </div>
      )
    }

    const brandOptions = this.props.brands.map((b, index) => {
      if (index === 0) {
        return { value: b.Name, label: translation(b.Name), disabled: true }
      }

      return { value: b.Name, label: b.Name }
    })
    return (
      <Panel title={translation('17904')}>
        <LabelWrapper labelText={translation('16517')}>
          <Inline fillChildNum={[0]} block>
            <DropDown name='brands' value={this.state.brands} onChange={onChange} options={brandOptions} isMulti />
            <AddButton onClick={addSetting} />
          </Inline>
        </LabelWrapper>

        {supplier.DeliverySettingsUrgent.map(renderDeliverySetting)}
      </Panel>
    )
  }

  render () {
    return (
      <Row>
        <Col>
          {this.renderSupplier()}
        </Col>
        <Col>
          {this.renderBooking()}
          {this.renderOrderingReply()}
          {this.renderPickup()}
        </Col>
        {this.state.supplier.Id > 0 && (
          <div>
            <Col span={3}>
              {this.renderDeliverySettings()}
            </Col>
            <Col span={3}>
              {this.renderUrgentDeliverySettings()}
            </Col>
          </div>
        )}
      </Row>
    )
  }

}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes,
    brands: state.common.brands,
    dracarUsable: state.auth.permissions.DracarUsable
  }
}

export default connect(mapStateToProps, {
  getSupplier,
  createSaveSupplier,
  updateSparePartDeliverySetting,
  getDracarStores
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/SparePartsSuppliers/View/index.js